<div class="error">
  <p><ng-content></ng-content></p>
</div>